import { network } from 'services/network';

export const extractResourceTableCardToCsv = (params) => {
    const fileName = params.fileName;
    delete params.fileName;

    return network.post('api/bo/extractResourceTableCardToCsv', params).then((response) => {
        const blob = new Blob([response.data], {
            type: 'text/plain',
        });
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = `${fileName}.csv`;
        a.click();

        return true;
    });
};
